import { useState, useEffect } from "react";

export default function QRCountdown({ validityPeriod }) {
  const getTimeLeft = () => {
    const diff = new Date(validityPeriod) - new Date();
    if (diff <= 0) return null;

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return { hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      const t = getTimeLeft();
      setTimeLeft(t);
      if (!t) clearInterval(timer);
    }, 1000);

    return () => clearInterval(timer);
  }, [validityPeriod]);

  if (!timeLeft) {
    return (
      <div className="flex items-center gap-2 text-sm font-medium text-red-500">
        <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
        QR Code Expired
      </div>
    );
  }

  const { hours, minutes, seconds } = timeLeft;
  const isUrgent = hours === 0 && minutes < 5;

  return (
    <div className="flex flex-col items-center gap-1">
      <p
        className={`text-xs font-medium ${isUrgent ? "text-red-400" : "text-gray-400"}`}
      >
        QR valid for
      </p>
      <div className="flex items-center gap-2">
        {/* Hours */}
        <div className="flex flex-col items-center">
          <span
            className={`text-2xl font-bold tabular-nums ${isUrgent ? "text-red-500" : "text-gray-800"}`}
          >
            {String(hours).padStart(2, "0")}
          </span>
        </div>
        <span
          className={`text-2xl font-bold ${isUrgent ? "text-red-500" : "text-gray-800"}`}
        >
          :
        </span>
        {/* Minutes */}
        <div className="flex flex-col items-center">
          <span
            className={`text-2xl font-bold tabular-nums ${isUrgent ? "text-red-500" : "text-gray-800"}`}
          >
            {String(minutes).padStart(2, "0")}
          </span>
        </div>
        <span
          className={`text-2xl font-bold ${isUrgent ? "text-red-500" : "text-gray-800"}`}
        >
          :
        </span>
        {/* Seconds */}
        <div className="flex flex-col items-center">
          <span
            className={`text-2xl font-bold tabular-nums ${isUrgent ? "text-red-500" : "text-gray-800"}`}
          >
            {String(seconds).padStart(2, "0")}
          </span>
        </div>
      </div>
    </div>
  );
}
